$(document).ready(function(){
    
    $(document).on('click', '.quick-add', function(event) {
        var handle = $(this).data('handle');
        const qvURL = `${window.shopUrl}/products/${handle}`;
        const qvContent = document.querySelector('#quickview_content');  
        $('#loading-spinner').show();
        $(qvContent).hide();
        fetch(`${qvURL}`)
            .then((response) => response.text())
            .then((responseText) => {     
                var product_info = $(responseText, 'text/html');
                var single_product = $('.single_product', product_info);
                $(qvContent).append(single_product);
                $('#loading-spinner').hide();
                $(qvContent).show();
                initializeSwiper();
            })
            .catch(err => {
                console.log(err);
                $('#loading-spinner').hide();
                $(qvContent).show();
            });

        $('.quick-view').addClass('show');
    });

    // Event delegation for close button click
    $(document).on('click', '.close-quick-view, .quick-view-overly', function() {
        $('.quick-view').removeClass('show');
        $('#quickview_content').empty();
    });
})
